import { useNavigate, useSearchParams } from "react-router-dom";
import { useGetMasterSparesVariantsQuery } from "../../../../services/master/masterSparesVariantApiSlice";
import classes from "./masterSparesVariantPage.module.css";
import { MasterSpareVariantTablePage } from "./masterSpareVariantTable/MasterSpareVariantTablePage";

export const MasterSparesVariantPage = () => {
  const [searchParams] = useSearchParams(); // FIXED
  const navigate = useNavigate();

  const brand = searchParams.get("brand") || "";
  const model = searchParams.get("model") || "";

  const { data, isLoading, isError } = useGetMasterSparesVariantsQuery({
    brand,
    model,
  });

  const handleAdd = () => {
  navigate(`/masters/spares/variants/add`);
};

  if (isLoading) return <div className={classes.loading}>Loading...</div>;
  if (isError) return <div className={classes.error}>Failed to load data.</div>;

  return (
    <div className={classes.box}>
      <div className={classes.head}>
        <div className={classes.head__item}>
          <h4 className={classes.head__title}>Brand</h4>
          <p className={classes.head__value}>{brand || "-"}</p>
        </div>

        <div className={classes.head__item}>
          <h4 className={classes.head__title}>Model</h4>
          <p className={classes.head__value}>{model || "-"}</p>
        </div>

        <div className={classes.head__item}>
          <h4 className={classes.head__title}>Variant Count</h4>
          <p className={classes.head__value__highlight}>{data?.length || 0}</p>
        </div>

        <button className={classes.head__btn} onClick={() => handleAdd("Add")}>
          Add Variant
        </button>
      </div>

      <MasterSpareVariantTablePage data={data} />
    </div>
  );
};
